<template>
	<div class="row" style="height: 100%" :key="modalKey">
		<div class="col-sm-12 col-md-12 col-lg-7 col-xl-8 pr-0" id="left-panel" style="display: flex; flex-direction: column;">
			<div class="bg-dark-noise modal-topbar p-2" style="display: flex; flex-direction: row;">
				<div class="d-flex justify-content-start align-self-center">
					<div @click="close" class="modal-button-sm modal-button--white"><i class="fas fa-times"></i></div>
				</div>
				<div class="d-flex justify-content-center" style="flex-grow: 100;">
					<table>
						<tr>
							<td colspan="3" style="line-height: 18px; font-size: 14px;"><b class="text-white" v-if="page.document !== null">{{page.document.document_name}}</b></td>
						</tr>
						<tr>
							<td align="left" style="line-height: 22px"><div @click="prev(page.type + '-' + page.id)" class="modal-button-sm modal-button--white" :class="{'modal-button--disabled' : hasPrev(page.type + '-' + page.id) === null}"><i class="fas fa-chevron-left"></i></div></td>
							<td align="center" style="line-height: 22px"><b class="text-white" style="font-size: 16px; vertical-align: bottom;">{{page.page + 1}} / {{page.document.last_page + 1}}</b></td>
							<td align="right" style="line-height: 22px"><div @click="next(page.type + '-' + page.id)" class="modal-button-sm modal-button--white" :class="{'modal-button--disabled' : hasNext(page.type + '-' + page.id) === null}"><i class="fas fa-chevron-right"></i></div></td>
						</tr>
					</table>
				</div>
			</div>
			<div id="openseadragon" ref="osd"></div>
			<div class="openseadragon-controls">
				<div id="zoom-in" class="modal-button control-button"><i class="fas fa-search-plus"></i></div>
				<div id="home" class="modal-button control-button"><i class="fas fa-home"></i></div>
				<div id="zoom-out" class="modal-button control-button"><i class="fas fa-search-minus"></i></div>
			</div>
		</div>
		<div class="col-sm-0 col-md-0 col-lg-5 col-xl-4 pl-0" id="right-panel">
			<transition name="component-fade" mode="out-in">
				<div v-if="!wikidataSearchFlag && !annotationFormFlag" style="height: 100%; display: flex; flex-direction: column;">
					<div class="bg-light-noise modal-topbar py-2">
						<div class="navbar modal-topbar-content" role="tablist">
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'general'}" @click="activeTab = 'general'" id="general-tab" data-toggle="tab" href="#general" role="tab" aria-controls="general" aria-selected="true">{{ __('translations.tab.general') }}</a>
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'annotation'}" @click="activeTab = 'annotation'" id="annotation-tab" data-toggle="tab" href="#annotation" role="tab" aria-controls="annotation" aria-selected="false">{{ __('translations.tab.annotation') }}<span v-show="page.annotations.length > 0">&nbsp;({{page.annotations.length}})</span></a>
							<a class="nav-link text-dark p-0" :class="{'active' : activeTab === 'history'}" @click="activeTab = 'history'" id="history-tab" data-toggle="tab" href="#history" role="tab" aria-controls="history" aria-selected="false">{{ __('translations.tab.history') }}</a>
						</div>
						<div class="float-right mr-3">
							<button class="btn btn-outline-secondary btn-sm btn-report" type="button" @click="$bvModal.show('report-issue-modal')" :disabled="page.is_reported === 1">{{ __('translations.button.report') }}</button>
						</div>
					</div>
					<div class="tab-content p-3" style="flex: 1; overflow-y: auto; overflow-x: hidden;" ref="tab-content">
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'general'}" id="general" role="tabpanel" aria-labelledby="general-tab">
							<transition name="message-fade">
								<div v-if="page.is_reported === 1" class="alert alert-warning py-1" role="alert">
									<small>{{ __('translations.message.page_issue') }} {{ __('translations.issue_type.' + page.reported_issue_type) }}</small>
								</div>
							</transition>
							<page-info :page="page"></page-info>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'annotation'}" id="annotation" role="tabpanel" aria-labelledby="annotation-tab">
							<annotations :artifact="page" v-on:annotation-selected="onAnnotationSelected"></annotations>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'history'}" id="history" role="tabpanel" aria-labelledby="history-tab">
							<activity-logs :artifact="page" v-if="activeTab === 'history'"></activity-logs>
						</div>
					</div>
				</div>
				<component v-else-if="annotationFormFlag" v-bind:is="annotationFormComponent" :artifact="page" :populateWith="annotationSelected" ref="annotationForm"></component>
			</transition>
		</div>
		
		<report-issue :artifact="page" v-on:reported="onReported"></report-issue>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import PageInfo from '../components/PageInfo'
import ModalMixin from '../mixins/ModalMixin'

export default {
	name: 'PageModal',
	mixins: [ModalMixin],
	components: {
		'page-info' : PageInfo,
	},
	computed: {
		...mapGetters([
			'page'
		]),
		modalKey() {
			// Changing the key re-renders the modal.
			return 'page-modal-' + this.page.id;
		}
	},
	methods: {
		openseadragon() {
			this.viewer = OpenSeadragon({
				id: 'openseadragon',
				tileSources: {
					"@context": "http://iiif.io/api/image/2/context.json",
			        "@id": this.page.iiif_root,
			        "profile": ["http://iiif.io/api/image/2/level2.json"],
			        "protocol": "http://iiif.io/api/image",
			        "width": this.page.iiif_info.width,
			        "height": this.page.iiif_info.height,
					"tiles": [{
				        "scaleFactors": this.page.iiif_info.tiles[0].scaleFactors,
				        "width": this.page.iiif_info.sizes[1].width,
				    }]
				},
				zoomInButton:  'zoom-in',
				zoomOutButton: 'zoom-out',
				homeButton:	   'home',
				zoomPerScroll: 1.1,
				showFullPageControl: false,
			});
			
			this.configureOpenseadragon();
		},
		onReported(issueType) {
			Vue.set(this.page, 'is_reported', 1);
			Vue.set(this.page, 'reported_issue_type', issueType);
		}
	}
}
</script>